// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/approval_task_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { ApprovalTaskService } from "./approval_task_service_pb";

/**
 * 承認案件 (= 申請済の入札) を業務プロセス横断で一覧取得する。
 * Phase 1 は spot / intraday 入札を fan-out 集約し、 PENDING / APPROVED / REJECTED
 * のみを返す。 ステータス / 業務プロセス / 権限の絞り込みは frontend 側で行う。
 *
 * @generated from rpc bffuser.v1.ApprovalTaskService.ListApprovalTasks
 */
export const listApprovalTasks = ApprovalTaskService.method.listApprovalTasks;
